function createCache() {
  const entries = new Map();
  return {
    entries,
    purge() {
      this.entries = new Map();
    },
  };
}

export default createCache;
